import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { LinehaulFloatingDataContext } from "../../Contexts/LinehaulFloatingDataContext";
import LinehaulFloatingActionMenu from "./LinehaulFloatingActionMenu";
import { UserDataContext } from "../../Contexts/UserDataContext";
import { getWeekDates, getFloatingRate } from "../../GlobalFunctions";
import { AppStateContext } from "../../Contexts/AppStateContext";

const useStyles = makeStyles((theme) => ({
  cell: {
    padding: theme.spacing(0.5),
    fontSize: "13px",
  },
  header: {
    padding: theme.spacing(0.5),
    fontSize: "13px",
    fontWeight: "bold",
  },
}));

const LinehaulDataTable = (props) => {
  const { data, truckId, week, day } = props;
  const { createFloatingModel } = useContext(LinehaulFloatingDataContext);
  const floatingModel = createFloatingModel({ week });
  const { userData } = useContext(UserDataContext);
  const displayColumns = [
    "km",
    "tripRate",
    "originBranchId",
    "destinationBranchId",
    "tripCost",
    "approvalState",
  ];

  const classes = useStyles();

  const [truckObj] = userData.trucks.filter(
    (truckObj) => truckObj.truckId === Number(truckId)
  );

  const { tableOpen, setTableOpen, scrollToPosition } =
    useContext(AppStateContext);

  // return to uses last position before a refresh was done
  useEffect(() => {
    scrollToPosition();
  }, [data, scrollToPosition]);

  truckObj.floatingRate = getFloatingRate(week, truckObj.truckPayments);
  return (
    <Table size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
          {displayColumns.map((col) => (
            <TableCell key={col} className={classes.header} align="left">
              {floatingModel[col].displayName}
            </TableCell>
          ))}
          <TableCell className={classes.header} align="left">
            Action
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {Object.keys(data).map((itemId) => {
          let row = data[itemId];
          row = {
            ...row,
            tripRate: truckObj.floatingRate,
            tripCost: truckObj.floatingRate * row.km,
          };

          return (
            <TableRow key={itemId}>
              {displayColumns.map((col) => {
                const value = row[col];
                return (
                  <TableCell key={col} className={classes.cell} align="left">
                    {floatingModel[col].displayValue(value)}
                  </TableCell>
                );
              })}

              <TableCell align="left">
                <LinehaulFloatingActionMenu
                  truckId={truckId}
                  itemData={row}
                  week={week}
                  day={day}
                  itemId={itemId}
                />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default LinehaulDataTable;

LinehaulDataTable.propTypes = {
  data: PropTypes.object.isRequired,
  truckId: PropTypes.number.isRequired,
  week: PropTypes.number.isRequired,
  day: PropTypes.number.isRequired,
};
